module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "ui pink button",
    on: {
      "click": _vm.openModal
    }
  }, [(_vm.checkedCategory) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.categoryName) + "\n    ")]) : _c('span', [_vm._v(" Select Category ")])]), _vm._v(" "), _c('modal', {
    ref: "modal"
  }, [_c('div', {
    staticClass: "tree"
  }, [_c('ul', {
    staticClass: "tree-list"
  }, [_c('branch', {
    attrs: {
      "branch": _vm.treeData,
      "handle-check": _vm.handleCheck,
      "checked-category": _vm.checkedCategory
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b80de0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tree.vue
// module id = 497
// module chunks = 1